import React, { useState, useCallback, useEffect } from "react";
import { Box } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import { callResearchApi } from "../../utils/researchApiAdapter";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setInputValue,
  setLoading,
  setRefData,
  setSelectedType,
} from "./referenceSlice";
import { sendErrorMail, sendSerpEmail } from "../../apiservice";
import Toast from "../../components/Toast";
import { getRefs } from "../references/refsSlice";
import { clearUser } from "../Admin/userSlice";
import { clearAllLitReview } from "../literature review/reviewSlice";
import { clearProject } from "../projects/projectSlice";
import { useParams, useNavigate } from "react-router-dom";
import InstructionsDialog from "./InstructionsDialog";
import DuplicateReferenceDialog from "../../components/DuplicateReferenceDialog";
import LandingHeader from "../../layout/header/index";
import OfferBanner from "../landing page/OfferBanner";
import Footer from '../../layout/footer/index'
import Login from "../authentication/login";  // Adjust path if needed
// import AIAgentWidget from "../../components/AIAgentWidget";
import ForgotPassword from "../Admin/ForgotPassword";  // Adjust path if needed
import Signup from "../authentication/sign up";  // Adjust path if needed
import { useLocation, Link } from "react-router-dom";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Helmet } from 'react-helmet-async';
import { canon } from '../../../src/seo';
import { newURL } from "../../../src/Secondgrouprepo"; // adjust path if needed
import "./CitationGenerator.css";
import ApaCitationContent from "./ApaCitationContent";
import MlaCitationContent from "./MlaCitationContent";
import HarvardCitationContent from "./HarvardCitationContent";
import BibtexCitationContent from "./BibtexCitationContent";
import MetadataCitationContent from "./MetadataCitationContent";
import ChicagoCitationContent from "./ChicagoCitationContent";



// ---- inline icon set (no external icon package) ----
const ICON_PATHS = {
  check: <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />,
  x: <path d="M18 6L6 18M6 6l12 12" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />,
  plus: <path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />,
  arrowDown: <path d="M12 4v16M5 13l7 7 7-7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  arrowUp: <path d="M12 20V4M5 11l7-7 7 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  chat: <path d="M4 5h16v11H8l-4 4V5z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />,
  chart: <path d="M4 20V10M12 20V4M20 20v-7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />,
  wand: (
    <>
      <path d="M4 20L15 9" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M14 3l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2zM19 9l.7 1.4L21 11l-1.3.6L19 13l-.7-1.4L17 11l1.3-.6L19 9z" fill="currentColor" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M12 7v5l3.5 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  shield: <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />,
  edit: <path d="M4 20l1-4L16 5l3 3L8 19l-4 1z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M3 12h18M12 3c2.5 2.5 3.8 6 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-6-3.8-9s1.3-6.5 3.8-9z" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </>
  ),
  hash: <path d="M5 8h14M5 16h14M10 4L8 20M16 4l-2 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />,
  download: (
    <>
      <path d="M12 3v13m0 0l-5-5m5 5l5-5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 20h16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </>
  ),
  doc: (
    <>
      <path d="M6 3h9l5 5v13H6z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9 12h6M9 16h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M20 20l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  link: <path d="M9 15l6-6M10 6l1.5-1.5a4 4 0 015.7 5.7L15.5 12M14 18l-1.5 1.5a4 4 0 01-5.7-5.7L8.5 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />,
  warning: (
    <>
      <path d="M12 3l10 18H2L12 3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M12 10v4M12 17v.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M12 11v5M12 8v.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </>
  ),
  graduation: (
    <>
      <path d="M2 9l10-5 10 5-10 5L2 9z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M6 11.5V17c0 1.5 2.7 3 6 3s6-1.5 6-3v-5.5M22 9v6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6M10 3v6.5L4.8 18a2 2 0 001.7 3h11a2 2 0 001.7-3L14 9.5V3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 15h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  briefcase: (
    <>
      <rect x="3" y="7.5" width="18" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M8 7.5V6a2 2 0 012-2h4a2 2 0 012 2v1.5M3 12.5h18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
    </>
  ),
  folder: <path d="M3 7a2 2 0 012-2h4l2 2.5h8A2 2 0 0121 9.5V18a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />,
  quote: <path d="M7 8c-1.8 1-3 2.8-3 5a3 3 0 003 3M17 8c-1.8 1-3 2.8-3 5a3 3 0 003 3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />,
  cpu: (
    <>
      <rect x="7" y="7" width="10" height="10" rx="1.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  book: (
    <>
      <path d="M4 5.5A2.5 2.5 0 016.5 3H12v18H6.5A2.5 2.5 0 014 18.5v-13z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M20 5.5A2.5 2.5 0 0017.5 3H12v18h5.5a2.5 2.5 0 002.5-2.5v-13z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </>
  ),
  video: (
    <>
      <rect x="3" y="6" width="13" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M16 10.5l5-3v9l-5-3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </>
  ),
  newspaper: (
    <>
      <path d="M4 6h13a2 2 0 012 2v11H6a2 2 0 01-2-2V6z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M19 8v9a2 2 0 002-2V9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M7 10h6M7 13h6M7 16h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </>
  ),
};

const PlanCell = ({ value }) => {
  if (value === "check") return <Icon name="check" className="yes" />;
  if (value === "x") return <Icon name="x" className="no" />;
  if (value && typeof value === "object") return <span className={`badge-${value.tone}`}>{value.badge}</span>;
  return value;
};

const Icon = ({ name, className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={style}>
    {ICON_PATHS[name]}
  </svg>
);

// FAQ accordion item
const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? " open" : ""}`}>
      <button type="button" className="faq-q" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        {question}
        <Icon name="plus" />
      </button>
      <div className="faq-a" style={{ maxHeight: open ? "300px" : "0" }}>
        <p>{answer}</p>
      </div>
    </div>
  );
};

// ---- static marketing content (generic/factual, not tied to redux state) ----
const STYLE_INFO = [
  { code: "APA", name: "APA Citation Generator", desc: "Use the APA citation generator when your paper follows APA style, especially for education, psychology, business, health sciences, and social sciences.", tags: ["APA citation generator", "APA format citation generator", "Free unlimited APA citation generator"] },
  { code: "HAR", name: "Harvard Citation Generator", desc: "Use the Harvard citation generator when your university or department asks for Harvard referencing, common in UK and international academic writing.", tags: ["Harvard citation generator", "Harvard style citation generator"] },
  { code: "MLA", name: "MLA Citation Generator", desc: "Use the MLA citation generator when your assignment needs MLA format, often used in English, literature, arts, and humanities.", tags: ["MLA citation generator", "MLA format citation generator", "Free MLA citation generator"] },
  { code: "CHI", name: "Chicago Citation Generator", desc: "Use the Chicago citation generator when your paper follows The Chicago Manual of Style, common in history, literature, and arts.", tags: ["Chicago citation generator", "Chicago style citation generator"] },
  { code: "BIB", name: "BibTeX Citation Generator", desc: "Use the BibTeX citation generator when you are writing in LaTeX or working with tools such as Overleaf.", tags: ["Generate BibTeX citation", "BibTeX citation generator"] },
  { code: "MTA", name: "Metadata Lookup", desc: "Use the metadata view to see the structured details behind a source (type, title, year, authors, and identifiers) before you format it.", tags: ["Research paper metadata", "Reference details lookup"] },
];

const SOURCE_TYPES = [
  { icon: "globe", tag: "Website", title: "Website Citation Generator", desc: "Cite webpages, blogs, online articles, and digital resources." },
  { icon: "book", tag: "Book", title: "Book Citation Generator", desc: "Create citations for print books, ebooks, and textbook chapters." },
  { icon: "doc", tag: "Journal Article", title: "Journal Article Citation Generator", desc: "Generate citations for scholarly journal articles and DOI-based sources." },
  { icon: "video", tag: "Video", title: "YouTube and Video Citation Generator", desc: "Cite YouTube videos, lectures, webinars, and interviews." },
  { icon: "newspaper", tag: "Newspaper", title: "Newspaper Citation Generator", desc: "Create citations for online and print newspaper articles." },
  { icon: "folder", tag: "Report", title: "Report Citation Generator", desc: "Cite research reports, white papers, and government reports." },
];

const EXAMPLE_CARDS = [
  { tag: "Journal Article · APA", cite: "Smith, J., & Lee, M. (2022). Understanding AI research. Journal of Technology, 15(3), 100–115. https://doi.org/xx.xxxx", intext: "In-text citation: (Smith & Lee, 2022)" },
  { tag: "Website · MLA", cite: 'ResearchPal. "How AI Tools Help Students Write Better." ResearchPal Blog, 2025, researchpal.co.', intext: "In-text citation: (ResearchPal)" },
];

const WHY_ITEMS = [
  { icon: "target", title: "Style-Based Formatting", desc: "For APA, MLA, Chicago, Harvard, and BibTeX." },
  { icon: "folder", title: "Source-Type Fields", desc: "For websites, books, journals, videos, reports, and more." },
  { icon: "edit", title: "Manual Editing", desc: "For incomplete or messy source data." },
  { icon: "quote", title: "In-Text & Full Reference", desc: "Generated together, every time." },
  { icon: "cpu", title: "BibTeX Output", desc: "Built for LaTeX users and Overleaf projects." },
  { icon: "book", title: "Bibliography Support", desc: "For longer, multi-source projects." },
];

const PLAN_COMPARISON = [
  { feature: "Generate APA citations", free: "check", premium: "check" },
  { feature: "Generate MLA citations", free: "check", premium: "check" },
  { feature: "Generate Chicago citations", free: "check", premium: "check" },
  { feature: "Copy citations", free: "check", premium: "check" },
  { feature: "Save bibliography lists", free: { badge: "Limited", tone: "limited" }, premium: { badge: "Unlimited", tone: "unlimited" } },
  { feature: "Export to Word or Google Docs", free: { badge: "Limited", tone: "limited" }, premium: "check" },
  { feature: "Bulk citation import", free: "x", premium: "check" },
];

const FAQS = [
  { q: "Is this citation generator free to use?", a: "Yes. You can paste a URL, DOI, ArXiv ID, PubMed ID, or title and generate a citation without paying." },
  { q: "Which citation styles are supported?", a: "APA, MLA, Chicago, and Harvard references, plus BibTeX entries and a metadata view. Switch between them using the style buttons above the input." },
  { q: "What can I paste into the generator?", a: "A website URL, a DOI, an ArXiv ID, a PubMed ID, or a title. Choose the matching type from the dropdown before you paste it in." },
  { q: "Can I copy the in-text citation as well as the full reference?", a: "Yes. When an in-text citation is available for your source, it appears below the full citation with its own copy button." },
  { q: "Should I double-check the result?", a: "Yes. Always compare the generated citation against your instructor's or journal's style guide, especially for page numbers, access dates, and edge cases the generator may not catch." },
];

const STRUCTURE_STEPS = ["Author", "Date", "Title", "Container / Publisher", "URL / DOI"];

const tabLabels = ["APA", "Harvard", "MLA", "Chicago", "BibTeX", "Metadata"];

const blogPosts = {
  0: {
    title: "APA Citation Generator – Free & Easy APA Citations",
    content: "",
    /* content (kept from previous code, commented out — not currently shown on the page):
    content: `
                   <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">APA Reference Tool – Simple and Free APA Citation Creation</h2> <br/>
                    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #353535CC;">
                        When writing academic papers, using the correct citation style is essential. One of the most widely used styles is the <strong> APA citation style,</strong> developed by the American Psychological Association. Our free <strong> APA citation generator</strong> helps students and researchers format references instantly, saving time and reducing errors.<br/><br/>
                        Whether you’re writing an essay, thesis, or journal article, here’s everything you need to know about <strong> APA citations</strong> and how to create them quickly.
                             </p><br/><br/><br/>
                        <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
                        What Is an APA Citation?
                        </h2><br/>

                       <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #353535CC;">
                         An <strong> APA citation</strong> is the standardized way of referencing sources in academic writing, most commonly used in psychology, education, social sciences, and business. The format ensures that readers can easily locate the original source of information.<br><br/>
                        APA citations generally include:<br/><br/>

                            <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
                            <li style="margin-bottom: 8px; color: #000;"> <strong>Author(s)</strong></li>
                        <li style="margin-bottom: 8px; color: #000;"> <strong>Publication year</strong></li>
                        <li style="margin-bottom: 8px; color: #000;"> <strong>Title of the work</strong></li>
                           <li style="margin-bottom: 8px; color: #000;"> <strong>Source details</strong> (journal, publisher, or DOI/link)</li>
                            </ul>
                                </p>

                              <br/><br/><br/>
                        <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
                                Why Use APA Style?
                         </h2><br/>

                      <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
                       Using APA style ensures your work is:<br/><br/>

                    <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
                      <li style="margin-bottom: 8px; color: #000;"><strong>Credible</strong> – Properly cites sources to avoid plagiarism.</li>
                     <li style="margin-bottom: 8px; color: #000;"><strong>Consistent</strong> – Standardized structure for all references.</li>
                       <li style="margin-bottom: 8px; color: #000;"><strong>Professional</strong> – Recognized internationally across journals and h.</li>
                           </ul>
                            </p>
<br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
    How to Format APA Citations
</h2><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
APA style requires two types of citations:<br/><br/>

<ol style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: decimal; padding-left: 40px;">
    <li style="margin-bottom: 12px; color: #000;">
        <strong>In-text citations</strong> – Short references within your essay or paper.
        <ul style="list-style-type: disc; padding-left: 40px; margin-top: 6px;">
            <li style="color: #000;">Example: (Smith, 2022)</li>
        </ul>
    </li>

    <li style="margin-bottom: 12px; color: #000;">
        <strong>Reference list citations</strong> – Full details of sources at the end.
        <ul style="list-style-type: disc; padding-left: 40px; margin-top: 6px;">
            <li style="color: #000;">
                Example: Smith, J. (2022). Understanding AI research.
                <em>Journal of Technology, 15</em>(3), 100–115.
                <a href="https://doi.org/xx.xxxx" style="color: blue;">https://doi.org/xx.xxxx</a>
            </li>
        </ul>
    </li>
</ol>
</p>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
    Common Types of APA Citations
</h2><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
Here are some examples of how APA citations look in different cases:<br/><br/>

<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
    <li style="margin-bottom: 12px; color: #000;">
        <strong>Book:</strong><br>
        Author, A. A. (Year). <em>Title of book</em>. Publisher.
    </li>
    <li style="margin-bottom: 12px; color: #000;">
        <strong>Journal Article:</strong><br>
        Author, A. A., & Author, B. B. (Year). Title of article.
        <em>Title of Journal, 10</em>(2), 100–110.
        <a href="https://doi.org/xxxxx" style="color: blue;">https://doi.org/xxxxx</a>
    </li>
    <li style="margin-bottom: 12px; color: #000;">
        <strong>Website:</strong><br>
        Author, A. A. (Year, Month Date). Title of page.
        <em>Website Name</em>.
        <a href="https://url.com" style="color: blue;">https://url.com</a>
    </li>
</ul>
</p>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
    Why Use an APA Citation Generator?
</h2><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
Manually formatting APA citations can be time-consuming and error-prone. A free <strong>APA citation generator</strong> like ResearchPal’s makes it effortless:<br/><br/>

<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
    <li style="margin-bottom: 10px; color: #000;">Enter a DOI, URL, or title.</li>
    <li style="margin-bottom: 10px; color: #000;">Get an instant APA citation in correct format.</li>
    <li style="margin-bottom: 10px; color: #000;">Copy it directly into your reference list.</li>
</ul><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
📌 Bonus: Our generator also provides citations in <strong>MLA, Chicago, Harvard, and BibTeX</strong> formats, so you can switch styles instantly.
</p>
</p>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Final Thoughts</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
Correct citations are critical for academic success. With our <strong>APA citation generator, </strong>you can create accurate APA references in seconds — freeing up more time for writing and research.<br/><br/>
 <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">👉Try the tool above to generate your first <strong>APA citation</strong> today.</p>
</p><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">
    Related Reading
</h2>

<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #000;
           list-style-type: disc; list-style-position: outside;
           padding-left: 40px; margin-top: 8px;">
    <li style="margin-bottom: 10px;">
        <a href="https://blog.researchpal.co/citation-management/apa-citation-generator-a-complete-guide-for-students-and-researchers/"
           style="color: blue; text-decoration: underline;">
           APA Citation Generator: A Complete Guide for Students and Researchers
        </a>
    </li>
    <li>
        <a href="https://blog.researchpal.co/citation-management/apa-vs-mla-differences/"
           style="color: blue; text-decoration: underline;">
           APA vs MLA: What’s the Difference and Which One Should You Use?
        </a>
    </li>
</ul>


        `,
    */
  },
  1: {
    title: "Harvard Citation Generator – Free & Accurate Harvard Citations",
    content: `
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Harvard Referencing Tool – Free and Precise Harvard Citation Maker</h2><br/>
    
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #353535CC;">
      The <strong>Harvard citation style </strong>is one of the most widely used referencing systems in academic writing, especially across humanities, social sciences, and business. 
      Our free <strong>Harvard citation generator</strong> makes it easy to create accurate references in seconds, ensuring your work is professional and plagiarism-free.<br/><br/>
      Here’s a quick guide to <strong>Harvard citations</strong> and how to format them properly.
    </p><br/><br/><br/>
    
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">What Is a Harvard Citation?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      A <strong>Harvard citation</strong> is a way of crediting sources in academic writing using an <strong>author–date system</strong>. This means:<br/><br/>
      <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
        <li style="margin-bottom: 8px; color: #000;"><strong>In-text citations</strong> include the author’s surname and year of publication.</li>
        <li style="margin-bottom: 8px; color: #000;">The full source details appear in a <strong>reference list</strong> at the end of the paper.</li>
      </ul>
    </p>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      <strong>Example:</strong><br/>
      <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px; margin-top: 8px;">
        <li style="color: #000;"><strong>In-text:</strong> (Taylor, 2021)</li>
        <li style="color: #000;"><strong>Reference list:</strong> Taylor, J. (2021). <em>Introduction to Research Methods</em>. Oxford University Press.</li>
      </ul>
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Why Use Harvard Style?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      The Harvard style is popular because it is:<br/><br/>
      <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
        <li style="margin-bottom: 8px; color: #000;"><strong>Simple</strong> – Easy to learn and apply consistently.</li>
        <li style="margin-bottom: 8px; color: #000;"><strong>Clear</strong> – Readers immediately know who the author is and when the work was published.</li>
        <li style="margin-bottom: 8px; color: #000;"><strong>Flexible</strong> – Accepted in many universities worldwide.</li>
      </ul>
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">How to Format Harvard Citations</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      Like APA, Harvard style has two main parts:<br/><br/>
      <ol style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: decimal; padding-left: 40px;">
        <li style="margin-bottom: 12px; color: #000;">
          <strong>In-text citation</strong> – Short form in parentheses.<br/>
          <ul style="list-style-type: disc; padding-left: 40px; margin-top: 6px;">
            <li style="color: #000;">Example: (Brown, 2020, p. 45)</li>
          </ul>
        </li>
        <li style="margin-bottom: 12px; color: #000;">
          <strong>Reference list entry</strong> – Full details of the source.
        </li>
      </ol>
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Common Examples</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      Here are some examples of Harvard references:<br/><br/>
      <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
        <li style="margin-bottom: 12px; color: #000;"><strong>Book:</strong><br/> Smith, A. (2019). <em>Understanding AI</em>. Cambridge University Press.</li>
        <li style="margin-bottom: 12px; color: #000;"><strong>Journal Article:</strong><br/> Lee, M. and Khan, R. (2020). Machine learning applications in education. <em>Journal of Technology Research, 12</em>(3), pp. 45–60.</li>
        <li style="margin-bottom: 12px; color: #000;"><strong>Website:</strong><br/> Johnson, P. (2022). Benefits of AI tools for students. <em>ResearchPal Blog</em>. Available at: <a href="https://researchpal.co" style="color: blue;">https://researchpal.co</a> [Accessed 10 August 2025].</li>
      </ul>
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Why Use a Harvard Citation Generator?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      Formatting Harvard citations manually can be confusing, especially with variations in punctuation, italics, and page numbers. 
      A <strong>Harvard citation generator</strong> saves time by:<br/><br/>
      <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040; list-style-type: disc; list-style-position: outside; padding-left: 40px;">
        <li style="margin-bottom: 10px; color: #000;">Instantly creating accurate citations from DOIs, URLs, or titles.</li>
        <li style="margin-bottom: 10px; color: #000;">Formatting both in-text and reference list entries.</li>
        <li style="margin-bottom: 10px; color: #000;">Reducing citation errors that can lead to lost marks.</li>
      </ul>
    </p>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      📌 With ResearchPal’s free tool, you can also switch between <strong>APA, MLA, Chicago, and BibTeX</strong> in one click.
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Final Thoughts</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      The Harvard style may look simple, but getting every comma and bracket right takes practice. 
      With our <strong>Harvard citation generator,</strong> you can create accurate citations instantly and focus more on your research and writing.<br/><br/>
      👉 Try the tool above to generate your first <strong>Harvard citation</strong> now.
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color: #404040;">Related Reading</h2>
    <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #000; list-style-type: disc; list-style-position: outside; padding-left: 40px; margin-top: 8px;">
      <li style="margin-bottom: 10px;">
        <a href="https://blog.researchpal.co/citation-management/harvard-reference-generator-a-complete-guide-for-students-and-researchers/" style="color: blue; text-decoration: underline;">
          Harvard Reference Generator: A Complete Guide for Students and Researchers
        </a>
      </li>
      <li>
        <a href="https://blog.researchpal.co/academic-writing/manage-references-under-deadlines/" style="color: blue; text-decoration: underline;">
          How to Manage References Like a Pro Under Deadlines
        </a>
      </li>
    </ul>
  `
  },
  2: {
    title: "MLA Citation Generator – Free & Reliable MLA Citations",
    content: `
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
     MLA Reference Creator – Trusted and Free MLA Citation Tool
    </h2><br/>

    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: #404040;">
      The <strong>MLA citation style,</strong> developed by the Modern Language Association, is one of the most commonly used referencing systems in academic writing — especially in the humanities, literature, and language studies. Our free <strong>MLA citation generator</strong> helps students and researchers create accurate citations instantly, saving valuable time and ensuring their work meets academic standards.<br/><br/>
      Here’s everything you need to know about <strong>MLA citations</strong> and how to format them.
    </p><br/><br/><br/>

  <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">What Is an MLA Citation?</h2><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
  An <strong>MLA citation </strong>gives credit to the original source of information used in your work. MLA uses
  a <strong>parenthetical citation system,</strong> meaning short in-text references point to full details in the
  Works Cited list at the end of your paper.<br/><br/>
  Example:<br/><br/>
  ● <strong>In-text:</strong> (Johnson 45)<br/>
  ●<strong> Works Cited entry:</strong> Johnson, Mark. <em>The Future of AI in Education</em>. Cambridge University Press, 2021.
</p><br/>

    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Why Use MLA Style?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; margin-bottom: 12px;">
      MLA is especially popular in the arts and humanities because it is:
    </p>
    <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
      <li style="margin-bottom: 8px;"><strong>Simple</strong> – Focuses on author and page number.</li>
      <li style="margin-bottom: 8px;"><strong>Reader-friendly</strong> – Avoids long in-text references.</li>
      <li style="margin-bottom: 8px;"><strong>Widely accepted</strong> – Standard in literature, languages, and history departments worldwide.</li>
    </ul>

    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">How to Format MLA Citations</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
      MLA requires two main parts:
    </p><br/>
  <ol style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: decimal;">
  <li style="margin-bottom: 10px;">
    <strong>In-text citations</strong> – Short references inside your essay.
    <ul style="list-style-type: disc; padding-left: 40px; margin-top: 6px; font-family: 'Red Hat Display'; font-size: 18px; color:#404040;">
      <li>Example: (Smith 2022, p. 12)</li>
    </ul>
  </li>
  <li style="margin-bottom: 10px;">
    <strong>Works Cited list</strong> – Full details of all sources at the end.
  </li>
</ol>


    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Common Examples</h2><br/>
    <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
      <li style="margin-bottom: 12px;"><strong>Book:</strong><br/>Smith, John. <em>Artificial Intelligence and Society</em>. Routledge, 2020.</li>
      <li style="margin-bottom: 12px;"><strong>Journal Article:</strong><br/>Taylor, Susan, and Michael Lee. “AI in Higher Education.” <em>Journal of Learning Studies</em>, vol. 15, no. 3, 2021, pp. 122–140.</li>
      <li style="margin-bottom: 12px;"><strong>Website:</strong><br/>ResearchPal. “How AI Tools Help Students Write Better.” <em>ResearchPal Blog</em>, 2025, <a href="https://researchpal.co" style="color:blue;">https://researchpal.co</a>.</li>
    </ul>

    <br/><br/>
 <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Why Use an MLA Citation Generator?</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
  Formatting MLA citations manually can be tricky, especially with italics, quotation marks, and page numbers. 
  A free <strong>MLA citation generator</strong> ensures:
</p><br/>
<ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 10px;">Instant generation of accurate MLA citations</li>
  <li style="margin-bottom: 10px;">Correct formatting for both in-text and Works Cited entries</li>
  <li style="margin-bottom: 10px;">Easy switching between MLA and other styles (APA, Harvard, Chicago, BibTeX)</li>
</ul>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; margin-top: 15px;">
  👉 With ResearchPal’s generator, you simply paste a title, DOI, or URL — and get a full formatted MLA citation in seconds.
</p>


    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Final Thoughts</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
      Correct citations are vital for academic success. With our <strong>MLA citation generator</strong>, you can quickly and accurately create references that follow MLA standards — giving you more time to focus on your writing.<br/><br/>
      👉 Try the tool above to generate your first <strong>MLA citation</strong> today.
    </p>

    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Related Reading</h2>
    <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#000; padding-left: 40px; list-style-type: disc; margin-top: 8px;">
      <li style="margin-bottom: 10px;">
        <a href="https://blog.researchpal.co/citation-management/mla-citation-generator-a-complete-guide-for-students-and-researchers/" style="color:blue; text-decoration:underline;">
          MLA Citation Generator: A Complete Guide for Students and Researchers
        </a>
      </li>
      <li>
        <a href="https://blog.researchpal.co/citation-management/apa-vs-mla-differences/" style="color:blue; text-decoration:underline;">
          APA vs MLA: What’s the Difference and Which One Should You Use?
        </a>
      </li>
    </ul>
  `
  },
  3: {
    title: "Chicago Citation Generator – Free & Accurate Chicago Citations",
    content: `
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Chicago Style Reference Tool – Free and Accurate Citation Builder
    </h2><br/>

    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: black">
      The <strong>Chicago citation style,</strong> created by the University of Chicago Press, is one of the most widely used referencing systems in academic writing. 
      It’s especially popular in history, law, and the social sciences. 
      Our free <strong>Chicago citation generator</strong> makes it easy to create accurate citations instantly, saving you from formatting errors and wasted time.<br/><br/>
      Here’s a quick guide to <strong>Chicago citations</strong> and how to format them correctly.
    </p><br/><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">What Is a Chicago Citation?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
      The <strong>Chicago Manual of Style (CMS)</strong> offers two different citation systems:
    </p><br/>
    <ol style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: decimal;">
     <li style="margin-bottom: 16px; color:#000;">
  <strong>Notes and Bibliography (NB)</strong> – Commonly used in humanities subjects. <br/><br/>
  <ul style="padding-left: 40px; list-style-type: disc;">
    <li style="margin-bottom: 10px;">Involves numbered footnotes or endnotes plus a bibliography.</li>
  <li style="margin-bottom: 10px; color:#000;">
  Example footnote: 1. 
  <span style="color:green;">
    John Smith, <em>Understanding AI</em> (Oxford University Press, 2021), 45.
  </span>
</li>

    <li style="margin-bottom: 10px; ">
      Example bibliography: Smith, John. <em>Understanding AI</em>. Oxford University Press, 2021.
    </li>
  </ul>
</li>

      <li style="margin-bottom: 12px; color:#000;">
        <strong>Author–Date</strong> – Used more often in sciences and social sciences.<br/><br/>
        <ul style="padding-left: 40px; list-style-type: disc;">
          <li style=" list-style-type: disc;">Similar to APA or Harvard.</li>
          <li style="; list-style-type: disc;">Example in-text: (Smith 2021, 45)</li>
          <li style=" list-style-type: disc;">Example reference list: Smith, John. 2021. <em>Understanding AI</em>. Oxford University Press.</li>
        </ul>
      </li>
    </ol>

    <br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Why Use Chicago Style?
</h2>
<br/>
<p style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; margin-bottom: 12px;">
  Chicago is highly valued because it is:
</p>
<ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 8px; color:#000;">
    <strong>Flexible</strong> – Offers two systems depending on discipline.
  </li>
  <li style="margin-bottom: 8px; color:#000;">
    <strong>Detailed</strong> – Ideal for complex works with many sources.
  </li>
  <li style="margin-bottom: 8px; color:#000;">
    <strong>Widely respected</strong> – Accepted by major journals and publishers.
  </li>
</ul>


    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">How to Format Chicago Citations</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040;">
      Examples in Notes and Bibliography Style:
    </p>
   <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li>
    <strong>Book (footnote):</strong><br/>
    <span style="color:green;">1. Jane Doe, <em>AI in Society</em> (Cambridge: Cambridge University Press, 2020), 22.</span>
  </li><br/>
  <li>
    <strong>Book (bibliography):</strong><br/>
    <span >Doe, Jane. <em>AI in Society</em>. Cambridge: Cambridge University Press, 2020.</span>
  </li><br/>
  <li>
    <strong>Journal Article:</strong><br/>
    <span style="color:green;">1. Michael Lee, “AI and Education,” <em>Journal of Technology Studies</em> 15, no. 3 (2021): 120–140.</span>
  </li><br/>
  <li>
    <strong>Website:</strong><br/>
    <span style="color:green;">1. ResearchPal, “How AI Tools Help Students,” <em>ResearchPal Blog</em>, 2025, 
      <a href="https://researchpal.co" style="color:blue;">https://researchpal.co</a>.
    </span>
  </li>
</ul>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Why Use a Chicago Citation Generator?</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040;">
      Because Chicago style has <strong>two systems</strong> and many detailed rules, manual formatting can be overwhelming. 
      A free <strong>Chicago citation generator</strong> helps by:
    </p><br/>
   <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 10px;">Instantly creating citations in both Notes & Bibliography and Author–Date formats</li>
  <li style="margin-bottom: 10px;">Handling punctuation, italics, and ordering automatically</li>
  <li style="margin-bottom: 10px;">Allowing quick switching between Chicago and other styles (APA, MLA, Harvard, BibTeX)</li>
</ul>
<br/>
    <p style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040;">
      📌 With ResearchPal’s citation generator, you just enter a DOI, title, or URL — and get perfectly formatted Chicago citation.
    </p>

    <br/><br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Final Thoughts</h2><br/>
    <p style="font-family: 'Red Hat Display'; font-size: 18px; color:#404040;">
      The Chicago style can seem complex, but with our <strong>Chicago citation generator</strong>, you’ll always get accurate, ready-to-use references in seconds. 
      Whether you’re working on history, law, or social sciences, this tool ensures your citations meet professional standards.<br/><br/>
      👉 Try the tool above to generate your first <strong>Chicago citation</strong> today.
    </p>

    <br/><br/>
    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">Related Reading</h2>
    <ul style="font-family: 'Red Hat Display'; font-size: 18px; color:#000; padding-left: 40px; list-style-type: disc;">
      <li><a href="https://blog.researchpal.co/citation-management/chicago-citation-generator-complete-guide/" style="color:blue; text-decoration:underline;">
        Chicago Citation Generator: A Complete Guide for Students and Researchers</a></li>
      <li><a href="https://blog.researchpal.co/citation-management/common-citation-mistakes/" style="color:blue; text-decoration:underline;">
        Are You Citing Sources Wrong? Common Citation Mistakes Explained</a></li>
    </ul>
  `
  }
  ,
  4: {
    title: "BibTeX Generator – Free & Accurate",
    content: `
  <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
    BibTeX Citation Creator – Free and Precise BibTeX Generator
  </h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color: black">
      For students, researchers, and academics working with LaTeX, <strong>BibTeX</strong> is essential for managing references in a professional and automated way. 
      Instead of manually typing long bibliographic details, you can use our free <strong>BibTeX generator</strong> to create ready-to-use entries instantly.<br/><br/>
      Here’s a guide to <strong>BibTeX </strong>and how our generator simplifies the process.
    </p><br/><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight:bold; font-size: 28px; color:#404040;">
      What Is BibTeX?
    </h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
     <strong> BibTeX</strong> is a reference management tool used with LaTeX — a typesetting system popular in academia, especially in mathematics, computer science, engineering, and physics. 
      A BibTeX entry is a structured record in a <code>.bib</code> file that contains all the details of a reference. LaTeX then formats it automatically into the bibliography according to the chosen style.
    </p><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Example of a BibTeX
    </h2><br/>
    <div style="background:#f7f7f7; border-left: 4px solid #404040; padding: 12px; margin: 10px 0; font-family: monospace; font-size: 16px; color:#333;">
      @proceedings-article{ITEM1,<br/>
      &nbsp;&nbsp;title={Efficient incident identification from multi-dimensional issue reports via meta-heuristic search},<br/>
      &nbsp;&nbsp;journal={Proceedings of the 28th ACM Joint Meeting on European Software Engineering Conference and Symposium on the Foundations of Software Engineering},<br/>
      &nbsp;&nbsp;pages={292--303},<br/>
      &nbsp;&nbsp;year={2020},<br/>
      &nbsp;&nbsp;publisher={ACM},<br/><br/>
      &nbsp;&nbsp;author={Gu, Jiazhen and Luo, Chuan and Qin, Si and Qiao, Bo and Lin, Qingwei and Zhang, Hongyu and Li, Ze and Dang, Yingnong and Cai, Shaowei and Wu, Wei and Zhou, Yangfan and Chintalapati, Murali and Zhang, Dongmei}<br/>
      }
    </div><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
  Every BibTeX entry begins with an entry type (e.g., 
  <span style="color:green"><code>@book</code></span>, 
  <span style="color:green"><code>@article</code></span>, 
  <span style="color:green"><code>@proceedings</code></span>) followed by details like 
  <span style="color:green">title</span>, 
  <span style="color:green">author</span>, 
  <span style="color:green">year</span>, 
  <span style="color:green">publisher</span>, etc.
</p>
<br/><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Why Use BibTeX?
    </h2><br/>
    <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
      <li style="margin-bottom: 10px; color:#000;"><strong>Automation</strong> – LaTeX handles formatting based on citation style.</li>
      <li style="margin-bottom: 10px; color:#000;"><strong>Accuracy</strong> – No missed commas or misplaced italics.</li>
      <li style="margin-bottom: 10px; color:#000;"><strong>Scalability</strong> – Easily manage hundreds of references in one .bib file.</li>
      <li style="margin-bottom: 10px; color:#000;"><strong>Flexibility</strong> – Works with multiple citation styles (APA, MLA, Chicago, etc.) through LaTeX packages.</li>
    </ul><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Why Use a BibTeX Generator?
    </h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
      Manually typing BibTeX entries is time-consuming and prone to formatting errors. A <strong>BibTeX generator</strong> saves you from this by:
    </p>
    <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
      <li style="margin-bottom: 10px; color:#000;">Instantly generating BibTeX entries from DOIs, titles, or URLs</li>
      <li style="margin-bottom: 10px; color:#000;">Structuring entries correctly for LaTeX use</li>
      <li style="margin-bottom: 10px; color:#000;">Supporting multiple entry types (books, articles, proceedings, websites, etc.)</li>
      <li style="margin-bottom: 10px; color:#000;">Allowing quick switching between BibTeX and other citation formats (APA, MLA, Chicago, Harvard)</li>
    </ul><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
      📌 With ResearchPal’s free generator, you can copy-paste a ready BibTeX entry directly into your <code>.bib</code> file.
    </p><br/><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Final Thoughts
    </h2><br/>
    <p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
      If you’re writing with LaTeX, BibTeX is your best friend for managing references. With our BibTeX generator, you can generate clean, accurate BibTeX entries in seconds — no more formatting mistakes or wasted time.<br/><br/>
      👉 Try the tool above to generate your first <strong>BibTeX</strong> now.
    </p><br/><br/>

    <h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
      Related Reading
    </h2>
    <ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#000; list-style-type: disc; list-style-position: outside; padding-left: 40px; margin-top: 8px;">
      <li style="margin-bottom: 10px;">
        <a href="https://blog.researchpal.co/citation-management/acs-citation-generator-guide/" style="color: blue; text-decoration: underline;">
          ACS Citation Generator: A Complete Guide for Students and Researchers
        </a>
      </li>
      <li>
        <a href="https://blog.researchpal.co/academic-research/citing-sources-wrong/" style="color: blue; text-decoration: underline;">
          Are You Citing Sources Wrong? Common Citation Mistakes Explained
        </a>
      </li>
    </ul>
  `
  },
  5: {
    title: "Research Paper Metadata",
    content: `
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Research Paper Metadata – Comprehensive Details for Citation and Indexing
</h2><br/>

<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
  When working with academic papers, it’s not just the content that’s important — the <strong>metadata</strong> also plays a critical role in research. 
  Metadata provides structured information about a paper, making it easier to find, organize, and cite sources.<br/><br/>
  Our <strong>citation generator</strong> not only creates references in APA, MLA, Harvard, Chicago, and BibTeX formats but also extracts available <strong> metadata</strong> from research papers to give you a clearer picture of your sources.
</p>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  What Is Metadata in Research Papers?
</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
  <strong>Metadata</strong> is the descriptive information about a paper that helps researchers quickly understand its context and details. 
  Typical research paper metadata includes:
</p><br/>
<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 8px; color:#000;"><strong>Type:</strong> Article, book chapter, proceedings paper, etc.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Title:</strong> The official title of the paper.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Year:</strong> Publication year.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Author(s):</strong> Full list of contributors.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Source:</strong> Journal, conference, or publisher.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>DOI/URL:</strong> Unique identifier or link to the paper.</li>
</ul>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Example of Research Paper Metadata
</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
  Here’s an example of how metadata might look when extracted from a paper:
</p><br/>
<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 8px; color:#000;"><strong>Type:</strong> proceedings-article</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Title:</strong> Efficient incident identification from multi-dimensional issue reports via meta-heuristic search</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Year:</strong> 2020</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Authors:</strong> Gu Jiazhen, Luo Chuan, Qin Si, Qiao Bo, Lin Qingwei, Zhang Hongyu, Li Ze, Dang Yingnong, Cai Shaowei, Wu Wei, Zhou Yangfan, Chintalapati Murali, Zhang Dongmei</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Source:</strong> Proceedings of the 28th ACM Joint Meeting on European Software Engineering Conference and Symposium on the Foundations of Software Engineering</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>URL:</strong> <a href="https://doi.org/10.1145/3368089.3409741" style="color: blue;">https://doi.org/10.1145/3368089.3409741</a></li>
</ul>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Why Is Metadata Important?
</h2><br/>
<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 8px; color:#000;"><strong>Searchability</strong> – Metadata makes academic papers easier to index and retrieve in databases.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Organization</strong> – Helps researchers manage libraries of papers with key details at a glance.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Citation Accuracy</strong> – Metadata ensures references include the correct title, author, and year.</li>
  <li style="margin-bottom: 8px; color:#000;"><strong>Research Insights</strong> – Metadata like author lists, sources, and keywords reveal a paper’s academic context.</li>
</ul>

<br/><br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  How ResearchPal Uses Metadata
</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040;">
  With <a href="https://researchpal.co/features/citation-generator" style="color: blue; text-decoration: underline;">ResearchPal’s citation generator</a>, you don’t just get formatted citations. The tool also:
</p><br/>
<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#404040; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 8px; color:#000;">Extracts <strong>metadata</strong> (authors, year, source, DOI, etc.) automatically</li>
  <li style="margin-bottom: 8px; color:#000;">Saves metadata alongside your references for quick access</li>
  <li style="margin-bottom: 8px; color:#000;">Displays it in your library for better project organization</li>
  <li style="margin-bottom: 8px; color:#000;">Uses metadata to generate structured insights in <a href="https://researchpal.co/features/paper-insights" style="color: blue; text-decoration: underline;">Paper Insights</a></li>
</ul>

<br/>
<br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Final Thoughts
</h2><br/>
<p style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:black">
  Metadata may look like just background details, but it’s the backbone of academic organization and citation accuracy. 
  With ResearchPal, you get both — <strong>accurate citations </strong>and the <strong>metadata</strong> you need to understand and manage your research effectively.<br/><br/>
  👉 Try the tool above to see the metadata automatically extracted from your paper.
</p>

<br/><br/>
<h2 style="font-family: 'Red Hat Display'; font-weight: bold; font-size: 28px; color:#404040;">
  Related Reading
</h2>
<ul style="font-family: 'Red Hat Display'; font-weight: 400; font-size: 18px; color:#000; padding-left: 40px; list-style-type: disc;">
  <li style="margin-bottom: 5px;">
    <a href="https://blog.researchpal.co/academic-research/how-to-find-open-access-research-papers-without-hitting-paywalls/" style="color: blue; text-decoration: underline;">How to Find Open Access Research Papers Without Hitting Paywalls</a>
  </li>
  <li style="margin-bottom: 5px;">
    <a href="https://blog.researchpal.co/academic-research/databases-every-researcher-should-bookmark/" style="color: blue; text-decoration: underline;">Top 10 Databases Every Researcher Should Bookmark</a>
  </li>
  <li style="margin-bottom: 5px;">
    <a href="https://blog.researchpal.co/academic-writing/from-confused-to-clear-how-to-structure-your-research-paper-in-less-time/" style="color: blue; text-decoration: underline;">From Confused to Clear: How to Structure Your Research Paper in Less Time</a>
  </li>
  <li>
    <a href="https://blog.researchpal.co/academic-writing/annotate-research-papers-efficiently/" style="color: blue; text-decoration: underline;">The Ultimate Guide to Annotating Research Papers Efficiently</a>
  </li>
</ul>
`
  },
};

const Indexbeforelogin = () => {
  // const [activeTab, setActiveTab] = useState(0);
  // const [refData, setRefData] = useState({});
  // const [loading, setLoading] = useState(false);
  // const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();
  const { tab } = useParams();
  const [copied, setCopied] = useState(false);
  const [copiedInText, setCopiedInText] = useState(false);
  const [refLoading, setRefLoading] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [openGuidelines, setOpenGuidelines] = useState(false);
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [duplicateReferenceTitle, setDuplicateReferenceTitle] = useState("");
  const [duplicateReferenceFull, setDuplicateReferenceFull] = useState("");
  const [showScroll, setShowScroll] = useState(false);
  const [showDummyResult, setShowDummyResult] = useState(false);
  const dispatch = useDispatch();
  const { activeTab, refData, loading, inputValue, selectedType } = useSelector(
    (state) => state.reference
  );
  const location = useLocation();
  const [state, setState] = useState({
    loginModal: location.state ? true : false, // Opens login modal if `location.state` is present
    forgotModal: false,
    signupModal: false,
    contactUsModal: false,
  });
  const [deviceFingerprint, setDeviceFingerprint] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredInText, setIsHoveredInText] = useState(false);
  const [hoverInTextCopy, setHoverInTextCopy] = useState(false);


  // Initialize fingerprint on component mount
  useEffect(() => {
    const generateFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setDeviceFingerprint(result.visitorId);

        // Store fingerprint in localStorage for future sessions
        localStorage.setItem('deviceFingerprint', result.visitorId);
      } catch (error) {
        console.error('Fingerprint generation failed:', error);
        // Fallback to session-based ID if fingerprint fails
        const sessionId = 'session-' + Math.random().toString(36).substr(2, 9);
        setDeviceFingerprint(sessionId);
        localStorage.setItem('deviceFingerprint', sessionId);
      }
    };

    // Check if fingerprint already exists
    const storedFingerprint = localStorage.getItem('deviceFingerprint');
    if (storedFingerprint) {
      setDeviceFingerprint(storedFingerprint);
    } else {
      generateFingerprint();
    }
  }, []);

  // New useEffect to sync activeTab with URL param on mount and when tab param changes
  useEffect(() => {
    const newTabIndex = tab ? tabMapping[tab.toLowerCase()] : 0; // Default to APA (0) if no tab
    if (newTabIndex !== undefined && newTabIndex !== activeTab) {
      dispatch(setActiveTab(newTabIndex));
    }
  }, [tab, dispatch, activeTab]);

  // Restore refData, inputValue, and selectedType from localStorage on mount
  // Restore refData, inputValue, and selectedType from localStorage on mount
  useEffect(() => {
    const storedRefData = localStorage.getItem('citationRefData');
    const storedInputValue = localStorage.getItem('citationInputValue');
    const storedSelectedType = localStorage.getItem('citationSelectedType');

    if (storedRefData && storedInputValue && storedSelectedType) {
      try {
        const parsedRefData = JSON.parse(storedRefData);
        if (parsedRefData?.data?.response && validateInput(storedSelectedType, storedInputValue)) {
          dispatch(setRefData(parsedRefData));
          dispatch(setInputValue(storedInputValue));
          dispatch(setSelectedType(storedSelectedType));
          console.log("Restored refData from localStorage:", parsedRefData);
        }
      } catch (error) {
        console.error("Failed to parse stored refData:", error);
        localStorage.removeItem('citationRefData'); // Clear invalid data
      }
    } else {
      // ✅ Set URL as default if no saved state exists
      dispatch(setSelectedType("url"));
    }
  }, [dispatch]);

  // Save refData, inputValue, and selectedType to localStorage when they change
  useEffect(() => {
    if (refData?.data?.response && inputValue && selectedType && validateInput(selectedType, inputValue)) {
      localStorage.setItem('citationRefData', JSON.stringify(refData));
      localStorage.setItem('citationInputValue', inputValue);
      localStorage.setItem('citationSelectedType', selectedType);
      console.log("Saved refData to localStorage:", refData);
    }
  }, [refData, inputValue, selectedType]);

  useEffect(() => {
    if (!inputValue) {
      setValidationError("");
      return;
    }

    const isValid = validateInput(selectedType, inputValue);

    if (!isValid) {
      switch (selectedType) {
        case "doi":
          setValidationError(
            "Must be a valid DOI e.g., 10.1145/3368089.3409741 or https://doi.org/10.1145/3368089.3409741"
          );
          break;
        case "arxiv_id":
          setValidationError(
            "Must be a valid ArXiv ID e.g., arXiv:2106.01345, 2106.01345 or https://arxiv.org/abs/2106.01345"
          );
          break;
        case "pubmed_id":
          setValidationError(
            "Must be a valid PubMed ID e.g., PMID: 38413730, 38413730 or https://pubmed.ncbi.nlm.nih.gov/38413730/"
          );
          break;
        case "title":
          setValidationError(
            "Must be a valid and meaningful phrase (e.g., Attention Is All You Need), cannot contain URLs, and must not exceed 200 characters."
          );
          break;
        case "url":
          setValidationError(
            "Must be a valid URL starting with https:// (e.g., https://example.com/article)"
          );
          break;
        default:
          setValidationError("");
      }
    } else {
      setValidationError("");
    }
  }, [selectedType]);

  const handleTypeChange = (e) => {
    dispatch(setSelectedType(e.target.value));
  };

  const tabMapping = {
    "apa": 0,
    "harvard": 1,
    "mla": 2,
    "chicago": 3,
    "bibtex": 4,
    "metadata": 5
  };
  const handleTabChange = (event, newValue) => {
    const tabName = Object.keys(tabMapping).find(
      key => tabMapping[key] === newValue
    );
    navigate(`/citation-generator/${tabName}`);
    dispatch(setActiveTab(newValue));
  };
  // const handleInputChange = (e) => {
  //   dispatch(setInputValue(e.target.value));
  // };

  const handleInputChange = (e) => {
    let val = e.target.value;

    // Remove leading/trailing spaces for identifiers, but only leading for titles (to allow typing)
    if (selectedType === "title") {
      val = val.trimStart();
    } else if (selectedType) {
      val = val.trim();
    }

    dispatch(setInputValue(val));

    if (!val) {
      setValidationError("");
      return;
    }

    const isValid = validateInput(selectedType, val);

    if (!isValid) {
      switch (selectedType) {
        case "doi":
          setValidationError(
            "Must be a valid DOI e.g., 10.1145/3368089.3409741 or https://doi.org/10.1145/3368089.3409741"
          );
          break;
        case "arxiv_id":
          setValidationError(
            "Must be a valid ArXiv ID e.g., arXiv:2106.01345, 2106.01345, https://arxiv.org/abs/2106.01345 or https://arxiv.org/html/2106.01345"
          );
          break;
        case "pubmed_id":
          setValidationError(
            "Must be a valid PubMed ID e.g., PMID: 38413730, 38413730 or https://pubmed.ncbi.nlm.nih.gov/38413730/"
          );
          break;
        case "title":
          setValidationError(
            "Must be a valid and meaningful phrase (e.g., Attention Is All You Need), cannot contain URLs, and must not exceed 200 characters."
          );
          break;
        case "url":
          setValidationError(
            "Must be a valid URL starting with https:// (e.g., https://example.com/article)"
          );
          break;
        default:
          setValidationError("");
      }
    } else {
      setValidationError("");
    }
  };

  // const handleCopy = () => {
  //   navigator.clipboard.writeText(getActiveContent());
  //   setCopied(true);
  //   setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
  // };
  const handleCopy = () => {
    const htmlString = getActiveContent();

    // Create a temporary element and set the HTML
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;

    // Get only the text content (strips all tags like <strong>, <a>, etc.)
    const plainText = tempElement.textContent || tempElement.innerText || "";

    navigator.clipboard.writeText(plainText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
  };

  const handleCopyInText = () => {
    const intext = refData?.data?.response?.intext_citation || "";
    navigator.clipboard.writeText(intext);
    setCopiedInText(true);
    setTimeout(() => setCopiedInText(false), 2000);
  };

  const getPlaceholderText = () => {
    switch (selectedType) {

      case "doi":
        return "Enter DOI here e.g 10.1145/3368089.3409741 or https://doi.org/10.1145/3368089.3409741";
      case "arxiv_id":
        return "Enter ArXiv ID here e.g., arXiv:2106.01345, 2106.01345, https://arxiv.org/abs/2106.01345, https://arxiv.org/html/2106.01345";
      case "pubmed_id":
        return "Enter PubMed ID here e.g., PMID: 38413730, 38413730, https://pubmed.ncbi.nlm.nih.gov/38413730/";
      case "title":
        return "Enter Title here e.g., Attention Is All You Need";
      case "url":
        return "Enter URL here e.g., https://example.com/article";
      default:
        return "Select a type first";
    }
  };

  const validateInput = (type, value) => {
    switch (type) {
      case "doi":
        return /^(https?:\/\/doi\.org\/10\.\d{4,9}\/(?!.*\.\.)[-._;()/:A-Z0-9]*[^.]|doi\.org\/10\.\d{4,9}\/(?!.*\.\.)[-._;()/:A-Z0-9]*[^.]|10\.\d{4,9}\/(?!.*\.\.)[-._;()/:A-Z0-9]*[^.])$/i.test(
          value
        );
      case "arxiv_id":
        return /^(arxiv:\d{4}\.\d{4,5}(v\d+)?|https:\/\/arxiv\.org\/(abs|pdf|html)\/\d{4}\.\d{4,5}(v\d+)?|\d{4}\.\d{4,5}(v\d+)?)$/i.test(
          value
        );
      case "pubmed_id":
        return /^(PMID:\s\d{8}|\d{8}|https:\/\/pubmed\.ncbi\.nlm\.nih\.gov\/\d{8}\/?|pubmed\.ncbi\.nlm\.nih\.gov\/\d{8}\/?)$/i.test(
          value
        );

      // case "title":
      //   return value.trim().length > 0;
      case "title":
        return (
          value.trim().length > 0 &&
          value.length <= 200 &&
          !/(https?:\/\/[^\s]+)|(www\.[^\s]+)|\b\w+\.(com|org|net|edu|gov|info|io|co|ai|in|uk|us)\b/i.test(
            value
          )
        );
      case "url":
        return /^https:\/\/.+/i.test(value);

      default:
        return false;
    }
  };

  const getActiveContent = useCallback(() => {
    if (!refData?.data?.response) return "";
    const responseData = refData.data.response;
    switch (activeTab) {
      case 0:
        return responseData.apa || "No APA available.";
      case 1:
        return responseData.harvard || "No Harvard available.";
      case 2:
        return responseData.mla || "No MLA available.";
      case 3:
        return responseData.chicago || "No Chicago available.";
      case 4:
        return responseData.bibtex || "No BibTeX available.";
      case 5:
        try {
          const htmlString = responseData.metadata.replace(
            /<a /g,
            "<a style='color: blue;' "
          );
          return htmlString;
        } catch (err) {
          return responseData.metadata || "No metadata available.";
        }
      default:
        return "";
    }
  }, [activeTab, refData]);

  // const handleGenerate = async () => {
  //   const email = localStorage.getItem("email");
  //   const token = localStorage.getItem("token");
  //   const projectId = localStorage.getItem("projectId");

  //   if (!inputValue || !email || !token) return;

  //   dispatch(setLoading(true));

  //   const payload = {
  //     referenceGenerator: true,
  //     email,
  //     token,
  //     value: inputValue,
  //     by: selectedType,
  //   };

  //   try {
  //     const res = await Repo.script(payload);
  //     console.log("Reference Generator Response:", res);

  //     dispatch(setRefData(res.data || {}));

  //     const errorMsg = res?.data?.data?.error;
  //     const responseText = res?.data?.data?.response;
  //     const sourceObj = res?.data?.data?.sourceObj || {};

  //     const isSourceEmpty = !sourceObj || Object.keys(sourceObj).length === 0;

  //     if (
  //       responseText === "Something went wrong!" ||
  //       errorMsg ||
  //       isSourceEmpty
  //     ) {
  //       const finalError = errorMsg || "Something went wrong!";
  //       Toast("error", finalError);

  //       sendErrorMail({
  //         user: email,
  //         feature: `Reference Generator, ${selectedType}`,
  //         error: isSourceEmpty ? "Empty response" : finalError,
  //         query: inputValue,
  //         ...(finalError.includes("limit") && { limitReachedError: true }),
  //       });

  //       return; // ✅ Skip saving
  //     }

  //     // ✅ Successful generation, now call saveReference

  //     const { bibtex, metadata, intext_citation, ...rest } = sourceObj;

  //     const referenceFormats = {
  //       ...rest,
  //       intextCitation: intext_citation,
  //     };

  //     const saveReferencePayload = {
  //       saveReference: true,
  //       researchProjectId: projectId,
  //       referenceFormats,
  //     };

  //     console.log("Saving reference:", saveReferencePayload);

  //     await Repo.script(saveReferencePayload);
  //     Toast("success", "References saved in reference section");
  //     dispatch(getRefs(projectId));
  //   } catch (err) {
  //     console.error("API Error:", err);
  //     sendErrorMail({
  //       user: email,
  //       feature: `Reference Generator, ${selectedType}`,
  //       error: err,
  //       query: inputValue,
  //     });
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };

  const handleGenerate = async () => {
    if (!selectedType) {
      Toast("error", "Please select Type");
      return;
    }
    if (!inputValue) {
      Toast("error", "Input Box is Empty!");
      return;
    }
    if (!validateInput(selectedType, inputValue)) {
      Toast("error", validationError || "Invalid input format!");
      return;
    }
    dispatch(setLoading(true));
    setShowDummyResult(false);
    setTimeout(() => {
      dispatch(setLoading(false));
      setShowDummyResult(true);
    }, 2000);
  };
  // Helper to get best available reference string
  const getBestReferenceString = (responseData, selectedType) => {
    const formats = ['reference', selectedType, 'apa', 'harvard', 'mla', 'chicago', 'bibtex', 'metadata'];
    for (const fmt of formats) {
      if (responseData[fmt]) return responseData[fmt];
    }
    return JSON.stringify(responseData, null, 2);
  };
  const handleAddToReferences = async () => {
    const deviceFingerprint = localStorage.getItem("deviceFingerprint");
    const projectId = localStorage.getItem("projectId");
    const responseData = refData?.data?.response; // Changed from sourceObj to response

    if (!responseData || Object.keys(responseData).length === 0) {
      Toast("error", "No citation found to add.");
      return;
    }

    const { intext_citation } = responseData;

    // Same payload as the logged-in reference generator (index.jsx)
    const references = {};
    const citationKey = intext_citation || `(Source, ${new Date().getFullYear()})`;
    references[citationKey] = {
      apa: responseData.apa || "",
      harvard: responseData.harvard || "",
      mla: responseData.mla || "",
      chicago: responseData.chicago || "",
      link: responseData.link || responseData.url || ""
    };

    const saveReferencePayload = {
      request: {
        method: "saveResearchReferences",
        data: {
          researchProjectId: projectId,
          references: references
        }
      }
    };
    try {
      setRefLoading(true);
      const response = await callResearchApi(saveReferencePayload);

      console.log("API Response:", response); // Debug log
      console.log("Response data:", response?.data); // Debug log
      console.log("API Response:", response);
      console.log("Response data:", response?.data);

      // Check if the response contains an error about duplicate reference
      // Try different possible response structures
      const errorMsg = response?.data?.error || response?.data?.data?.error;

      if (errorMsg && errorMsg.includes("already exist")) {
        // Get full reference in selected format
        const fullRef = getBestReferenceString(responseData, selectedType);
        setDuplicateReferenceFull(fullRef);
        setDuplicateReferenceTitle(responseData.title || responseData.doi || inputValue);
        setDuplicateDialogOpen(true);
        return;
      }

      // Also check for the exact error message format
      if (errorMsg === "This reference already exist in the references section!") {
        const fullRef = getBestReferenceString(responseData, selectedType);
        setDuplicateReferenceFull(fullRef);
        setDuplicateReferenceTitle(responseData.title || responseData.doi || inputValue);
        setDuplicateDialogOpen(true);
        return;
      }

      // If no error, proceed with success
      Toast("success", "Citation saved in citations section");
      dispatch(getRefs(projectId));
    } catch (err) {
      console.error("Save citation error:", err);
      console.log("Error response data:", err?.response?.data); // Debug log
      console.log("Error response data:", err?.response?.data);

      // Check if the error response contains duplicate reference message
      // Try different possible response structures
      const errorMsg = err?.response?.data?.error || err?.response?.data?.data?.error;

      if (errorMsg && errorMsg.includes("already exist")) {
        const fullRef = getBestReferenceString(responseData, selectedType);
        setDuplicateReferenceFull(fullRef);
        setDuplicateReferenceTitle(responseData.title || responseData.doi || inputValue);
        setDuplicateDialogOpen(true);
        return;
      }

      // Also check for the exact error message format in error response
      if (errorMsg === "This reference already exist in the references section!") {
        const fullRef = getBestReferenceString(responseData, selectedType);
        setDuplicateReferenceFull(fullRef);
        setDuplicateReferenceTitle(responseData.title || responseData.doi || inputValue);
        setDuplicateDialogOpen(true);
        return;
      }

      sendErrorMail({
        user: deviceFingerprint,
        feature: `Reference Generator, ${selectedType}`,
        error: err,
        query: inputValue,
      });
    } finally {
      setRefLoading(false); // Stop loading
      setRefLoading(false);
    }
  };

  const handleViewDuplicateReference = () => {
    setDuplicateDialogOpen(false);
    // Navigate to references page with a flag to highlight the duplicate reference
    // Use absolute path to go to the correct references route
    const projectTitle = localStorage.getItem("projectTitle");
    navigate(`/projects/${projectTitle}/citation`, {
      state: {
        highlightDuplicate: true,
        duplicateTitle: duplicateReferenceTitle
      }
    });
  };

  const toggle = (name) => {
    if (name === "forgotModal" || name === "signupModal") {
      setState((prev) => ({ ...prev, [name]: !prev[name], loginModal: false }));
    } else {
      setState((prev) => ({ ...prev, [name]: !prev[name] }));
    }
  };

  // "Get Started" CTAs: no raw /pricing link. Logged-in → pricing; otherwise → login popup.
  const handleGetStarted = () => {
    if (localStorage.getItem("token")) {
      navigate("/pricing");
    } else {
      toggle("loginModal");
    }
  };

  const handleCloseDuplicateDialog = () => {
    setDuplicateDialogOpen(false);
    setDuplicateReferenceTitle("");
    setDuplicateReferenceFull("");
  };

  const Identifiers = [
    { name: "URL", value: "url" },

    { name: "DOI", value: "doi" },
    { name: "ArXiv ID", value: "arxiv_id" },
    { name: "PubMed ID", value: "pubmed_id" },
    { name: "Title", value: "title" },

  ];

  // useEffect(() => {
  //     // Check if email is in localStorage
  //     const email = localStorage.getItem("email");

  //     // If email is not found, dispatch the getUser action
  //     if (!email) {
  //         Toast("error", "Session is expired! Please Login again");
  //         localStorage.clear();
  //         dispatch(clearUser());
  //         // dispatch(clearAllInsights());
  //         dispatch(clearAllLitReview());
  //         dispatch(clearProject());
  //         navigate("/");
  //     }
  // }, [dispatch]);


  const TAB_META = {
    // base page (no style selected)
    __base: {
      title: 'Free Citation Generator: APA, MLA, Harvard & Chicago',
      desc: 'Generate accurate citations free for APA, MLA, Harvard, Chicago & BibTeX. Paste a URL, DOI or title to get full references + in-text citations instantly.',
      path: '/citation-generator',
    },

    apa: {
      title: 'Free APA Citation Generator – Instant',
      desc: 'Create accurate APA citations free in seconds. Paste a URL, DOI or title for a full reference + matching in-text citation. Try For Free Now!',
      path: '/citation-generator/apa',
    },
    harvard: {
      title: 'Free Harvard Citation Generator – Author-Date Style',
      desc: 'Generate accurate Harvard style references free in seconds. Get the full reference list entry plus the matching in-text citation. Try For Free Now!',
      path: '/citation-generator/harvard',
    },
    mla: {
      title: 'Free MLA Citation Generator – Instant',
      desc: 'Build MLA Works Cited entries free in seconds. Paste a URL, DOI or title for a full citation + matching in-text reference. Try For Free Now!',
      path: '/citation-generator/mla',
    },
    chicago: {
      title: 'Free Chicago Citation Generator – Notes & Author-Date',
      desc: 'Generate Chicago Manual of Style citations free. Switch between Notes-Bibliography and Author-Date, plus matching footnotes. Try For Free Now!',
      path: '/citation-generator/chicago',
    },
    bibtex: {
      title: 'Free BibTeX Citation Generator – For LaTeX & Overleaf',
      desc: 'Generate BibTeX entries free for @article, @book, @misc & more. Paste a URL, DOI or ArXiv ID for a ready-to-paste .bib citation. Try For Free Now!',
      path: '/citation-generator/bibtex',
    },
    metadata: {
      title: 'Free Metadata Citation Generator – APA, MLA & More',
      desc: "Paste a URL, DOI or ISBN to pull a source's metadata free, then format it as APA, MLA, Harvard, Chicago or BibTeX instantly. Try For Free Now!",
      path: '/citation-generator/metadata',
    },
  };

  const key = (tab ?? '').toLowerCase();
  const meta = TAB_META[key] ?? TAB_META.__base;
  const url = canon(meta.path);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 300) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 300) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScroll]);

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.desc} />
        <link rel="canonical" href={canon(meta.path)} />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.desc} />
        <script type="application/ld+json">
          {`{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://researchpal.co/#organization",
      "name": "ResearchPal",
      "url": "https://researchpal.co/",
      "email": "info@researchpal.co",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Level 1, Devonshire House, One Mayfair Place",
        "addressLocality": "London",
        "postalCode": "W1J 8AJ",
        "addressCountry": "GB"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://researchpal.co/#website",
      "url": "https://researchpal.co/",
      "name": "ResearchPal",
      "publisher": {
        "@id": "https://researchpal.co/#organization"
      },
      "inLanguage": "en"
    },
    {
      "@type": "WebPage",
      "@id": "https://researchpal.co/citation-generator#webpage",
      "url": "https://researchpal.co/citation-generator",
      "name": "Free Citation Generator: APA, MLA, Chicago & More",
      "description": "Generate APA, MLA, Chicago, Harvard and BibTeX citations from URLs, DOIs, titles, ArXiv IDs and PubMed IDs.",
      "inLanguage": "en",
      "isPartOf": {
        "@id": "https://researchpal.co/#website"
      },
      "publisher": {
        "@id": "https://researchpal.co/#organization"
      },
      "breadcrumb": {
        "@id": "https://researchpal.co/citation-generator#breadcrumb"
      },
      "mainEntity": {
        "@id": "https://researchpal.co/citation-generator#application"
      },
      "hasPart": [
        {
          "@id": "https://researchpal.co/citation-generator#faq"
        },
        {
          "@id": "https://researchpal.co/citation-generator#howto"
        }
      ]
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://researchpal.co/citation-generator#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://researchpal.co/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Citation Generator",
          "item": "https://researchpal.co/citation-generator"
        }
      ]
    },
    {
      "@type": "WebApplication",
      "@id": "https://researchpal.co/citation-generator#application",
      "name": "ResearchPal Citation Generator",
      "url": "https://researchpal.co/citation-generator",
      "description": "Generate APA, MLA, Chicago, Harvard and BibTeX citations from URLs, DOIs, titles, ArXiv IDs and PubMed IDs.",
      "applicationCategory": "ReferenceApplication",
      "applicationSubCategory": "Citation Generator",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript and a modern web browser",
      "inLanguage": "en",
      "isAccessibleForFree": true,
      "provider": {
        "@id": "https://researchpal.co/#organization"
      },
      "mainEntityOfPage": {
        "@id": "https://researchpal.co/citation-generator#webpage"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://researchpal.co/citation-generator",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free plan or free basic access is available."
      },
      "featureList": [
        "APA citation generation",
        "MLA citation generation",
        "Chicago citation generation",
        "Harvard citation generation",
        "BibTeX generation",
        "DOI, ArXiv and PubMed metadata lookup",
        "In-text citation generation",
        "Citation copying, saving and export"
      ]
    },
    {
      "@type": "FAQPage",
      "@id": "https://researchpal.co/citation-generator#faq",
      "url": "https://researchpal.co/citation-generator#faq",
      "name": "Citation Generator Frequently Asked Questions",
      "isPartOf": {
        "@id": "https://researchpal.co/citation-generator#webpage"
      },
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is this citation generator free to use?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You can paste a URL, DOI, ArXiv ID, PubMed ID or title and generate a citation without paying."
          }
        },
        {
          "@type": "Question",
          "name": "Which citation styles are supported?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "APA, MLA, Chicago and Harvard references are supported, along with BibTeX entries and a metadata view."
          }
        },
        {
          "@type": "Question",
          "name": "What can I paste into the generator?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can paste a website URL, DOI, ArXiv ID, PubMed ID or title after choosing the matching identifier type."
          }
        },
        {
          "@type": "Question",
          "name": "Can I copy the in-text citation as well as the full reference?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. When an in-text citation is available, it appears below the full citation with its own copy option."
          }
        },
        {
          "@type": "Question",
          "name": "Should I double-check the result?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Compare the generated citation with your instructor's or journal's style guide, especially for page numbers, access dates and unusual source types."
          }
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://researchpal.co/citation-generator#howto",
      "url": "https://researchpal.co/citation-generator#howto",
      "name": "How to Use the ResearchPal Citation Generator",
      "description": "Generate a formatted academic citation from a URL, DOI, title or supported academic identifier.",
      "inLanguage": "en",
      "isPartOf": {
        "@id": "https://researchpal.co/citation-generator#webpage"
      },
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "Choose Your Citation Style",
          "text": "Select APA, Harvard, MLA, Chicago, BibTeX or Metadata."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "Select the Identifier Type",
          "text": "Choose URL, DOI, ArXiv ID, PubMed ID or Title."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "Paste the Source Details",
          "text": "Enter the link, identifier or title you want to cite."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "Review the Citation",
          "text": "Check that the author, title, date and URL look correct."
        },
        {
          "@type": "HowToStep",
          "position": 5,
          "name": "Copy It",
          "text": "Copy the full citation and the in-text citation, when available, into your reference list."
        }
      ]
    }
  ]
}`}
        </script>
      </Helmet>
      {/* <OfferBanner /> */}
      {/* Sticky header (same style as other pages) */}
      <Box
        sx={{
          zIndex: 1100,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: { xs: "64px", md: "86px" },
          backgroundColor: "transparent",
        }}
      >
        {/* pass a safe wrapper to LandingHeader so parent handles navigation */}
        <LandingHeader
          onClick={(arg) => {
            // Handle modal toggles
            if (["loginModal", "signupModal", "forgotModal"].includes(arg)) {
              toggle(arg);
            }
            // Existing navigation handling
            else if (typeof arg === "string" && arg.startsWith("/")) {
              navigate(arg);
            }
            // Otherwise ignore or handle other cases if needed
          }}
        />
      </Box>

      <div className="citation-landing-body" id="reference-generator">
        {/* ===== HERO TOOL ===== */}
        <section className="hero-tool" id="citation-tool">
          <div className="bg-ambient" aria-hidden="true">
            <div className="blob blob-a" />
            <div className="blob blob-b" />
            <div className="blob blob-c" />
          </div>
          <div className="container">
            <p className="eyebrow" style={{ textAlign: "center", margin: 0 }}>Free Citation Generator</p>

            <div className="tool-panel">
              <div className="mode-row" role="group" aria-label="Choose citation style">
                {tabLabels.map((label, idx) => (
                  <Link
                    key={label}
                    to={`/citation-generator/${label.toLowerCase()}`}
                    className={`mode-pill${key === label.toLowerCase() ? " active" : ""}`}
                    onClick={() => handleTabChange(null, idx)}
                  >
                    {label}
                  </Link>
                ))}
              </div>

              <div className="tool-form">
                <div className="field">
                  <label className="field-label" htmlFor="cg-source-type">Select Type</label>
                  <select
                    id="cg-source-type"
                    name="identifierType"
                    value={selectedType}
                    onChange={handleTypeChange}
                  >
                    {Identifiers.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field">
                  <label className="field-label" htmlFor="cg-source-input">Enter source details</label>
                  <input
                    id="cg-source-input"
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder={getPlaceholderText()}
                    disabled={!selectedType}
                  />
                  {validationError ? (
                    <p className="tool-error">{validationError}</p>
                  ) : (
                    <span className="field-hint">Paste a DOI, ArXiv ID, PubMed ID, title, or URL of the source you want to cite.</span>
                  )}
                </div>
              </div>

              <div className="tool-actions">
                <button type="button" className="btn-primary" disabled={loading} onClick={handleGenerate}>
                  {loading ? <TailSpin height={16} width={16} color="#fff" /> : <Icon name="wand" />}
                  {loading ? "Generating…" : "Generate Citation Free"}
                </button>
                <button type="button" className="btn-secondary" onClick={() => setOpenGuidelines(true)}>
                  See Guidelines
                </button>
              </div>

              <div className="output-panel">
                <div className="output-head">
                  <span>Your Citation</span>
                  {!loading && getActiveContent()?.trim() && (
                    <button
                      type="button"
                      className={`copy-btn${copied ? " is-copied" : ""}`}
                      onClick={handleCopy}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      {copied ? "Copied!" : "Copy"}
                    </button>
                  )}
                </div>

                <div className="output-box">
                  {loading ? (
                    <div className="skeleton">
                      <span /><span /><span /><span />
                    </div>
                  ) : showDummyResult ? (
                    <div className="lr-dummy-result">
                      <p className="lr-dummy-result__text" style={{ padding: "16px", margin: 0 }}>Smith, J. (2024). A comprehensive study on citation generation and its impact on academic integrity. Journal of Academic Research, 12(4), 112-130. https://doi.org/10.1234/jar.2024.001</p>
                      <div className="lr-dummy-result__overlay">
                        <button
                          type="button"
                          className="lr-dummy-result__login-btn"
                          onClick={() => setState((prev) => ({ ...prev, loginModal: true }))}
                        >
                          Login to see the full result
                        </button>
                      </div>
                    </div>
                  ) : !getActiveContent()?.trim() ? (
                    <p className="placeholder">Once you select a citation style, your results will show up here.</p>
                  ) : activeTab === 5 ? (
                    <div className="output-text is-prose" dangerouslySetInnerHTML={{ __html: getActiveContent() }} />
                  ) : (
                    <pre className="output-text">{getActiveContent()}</pre>
                  )}
                </div>

                {!loading && !([4, 5].includes(activeTab)) && refData?.data?.response?.intext_citation?.trim() && (
                  <div className="output-box">
                    <span className="output-sub-label">In-text citation</span>
                    <pre className="output-text">{refData.data.response.intext_citation}</pre>
                    <button
                      type="button"
                      className={`copy-btn is-floating${copiedInText ? " is-copied" : ""}`}
                      onClick={handleCopyInText}
                      onMouseEnter={() => setIsHoveredInText(true)}
                      onMouseLeave={() => setIsHoveredInText(false)}
                    >
                      {copiedInText ? "Copied!" : "Copy"}
                    </button>
                  </div>
                )}
              </div>

              <ul className="trust-row">
                <li><Icon name="check" />Free to try</li>
                <li><Icon name="check" />No complicated setup</li>
                <li><Icon name="check" />No formatting guesswork</li>
             
                <li><Icon name="check" />Your input remains private</li>

                                <li><Icon name="check" />Verified Citations</li>

              </ul>
            </div>

            <p className="tool-note">No complicated setup. No formatting guesswork. Add your source details and create a citation you can copy, save, or export. <a href="#pricing">Compare free and premium features below.</a></p>

            <div className="structure-cycle" aria-hidden="true">
              <span className="structure-cycle-label">Every citation follows the same anatomy</span>
              <div className="structure-track">
                {STRUCTURE_STEPS.map((step, i) => (
                  <React.Fragment key={step}>
                    <div className="structure-node"><span className="structure-pill">{step}</span></div>
                    {i < STRUCTURE_STEPS.length - 1 && <span className="structure-arrow">→</span>}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </section>

        {key === 'apa' ? (
          <ApaCitationContent />
        ) : key === 'mla' ? (
          <MlaCitationContent />
        ) : key === 'harvard' ? (
          <HarvardCitationContent />
        ) : key === 'bibtex' ? (
          <BibtexCitationContent />
        ) : key === 'metadata' ? (
          <MetadataCitationContent />
        ) : key === 'chicago' ? (
          <ChicagoCitationContent />
        ) : (
          <>
        {/* ===== HERO COPY ===== */}
        <section className="hero-copy">
          <div className="container hero-copy-inner">
            <h1>Free Citation Generator: APA, MLA, Chicago, Harvard & BibTeX References</h1>
            <p className="lede">Need to cite a website, book, journal article, video, report, or research paper? Our free citation generator helps you create properly formatted citations in seconds, without making citation rules feel harder than the assignment itself.</p>
            <p className="lede" style={{ marginTop: "-14px" }}>Choose your style, enter your source details, and generate citations for APA, MLA, Chicago, Harvard, or BibTeX. You can create full references, in-text citations, bibliography entries, and BibTeX records from one simple workspace.</p>
            <div className="hero-ctas">
              <span role="button" tabIndex={0} className="btn-primary" style={{ textDecoration: "none", cursor: "pointer" }} onClick={handleGetStarted} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleGetStarted(); } }}>Get Started</span>
              <Link to="/demo" state={{ demoTab: "Citation Generator" }} className="btn-secondary" style={{ textDecoration: "none" }}>See Demo</Link>
            </div>
          </div>
        </section>

        {/* ===== BENEFITS BAR ===== */}
        <section className="benefits-bar">
          <div className="container benefits-inner">
            <span className="benefit-chip"><Icon name="clock" />Create citations faster</span>
            <span className="benefit-chip"><Icon name="check" />Supports major citation styles</span>
            <span className="benefit-chip"><Icon name="quote" />Build in-text citations</span>
            <span className="benefit-chip"><Icon name="edit" />Save time on formatting</span>
            <span className="benefit-chip"><Icon name="wand" />Edit source details manually</span>
            <span className="benefit-chip"><Icon name="download" />Copy, save, or export</span>
          </div>
        </section>

        {/* ===== WHAT IS A CITATION GENERATOR ===== */}
        <section className="section section-alt" id="what-is">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">The basics</span>
              <h2>What Is a Citation Generator?</h2>
            </div>
            <div className="direct-answer">&quot;A citation generator turns source information into a formatted academic citation, so you don&apos;t have to arrange every author name, date, title, publisher, page number, URL, or DOI by hand.&quot;</div>
            <div className="grid-2">
              <div className="card">
                <h3>How It Works</h3>
                <p>Instead of arranging every detail by hand, you enter the source details and the tool formats them according to the citation style you choose.</p>
              </div>
              <div className="card">
                <h3>Why It Helps</h3>
                <p>A good citation generator does not just save time. It helps you stay organized, reduce formatting mistakes, and give proper credit to the sources you use.</p>
              </div>
            </div>
          </div>
        </section>

        {/* ===== CITATION STYLES ===== */}
        <section className="section" id="styles">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">Pick your format</span>
              <h2>Which Citation Styles Can You Generate?</h2>
              <p className="lede">Different schools, universities, journals, and instructors ask for different citation styles.</p>
            </div>
            {STYLE_INFO.map((s, idx) => (
              <div className="style-block" id={tabLabels[idx].toLowerCase()} key={s.code}>
                <div className="style-head">
                  <div className="style-badge">{s.code}</div>
                  <h3 style={{ margin: 0 }}>{s.name}</h3>
                </div>
                <p>{s.desc}</p>
                <div className="chip-cloud">
                  {s.tags.map((t) => <span key={t}>{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ===== HOW IT WORKS ===== */}
        <section className="section section-alt" id="how-it-works">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">Five simple steps</span>
              <h2>How to Use Our Free Citation Generator</h2>
            </div>
            <ol className="num-steps">
              <li className="num-step"><span className="num-badge">1</span><div><h3>Choose Your Citation Style</h3><p>Select APA, Harvard, MLA, Chicago, BibTeX, or Metadata.</p></div></li>
              <li className="num-step"><span className="num-badge">2</span><div><h3>Select the Identifier Type</h3><p>Choose URL, DOI, ArXiv ID, PubMed ID, or Title.</p></div></li>
              <li className="num-step"><span className="num-badge">3</span><div><h3>Paste the Source Details</h3><p>Enter the link, identifier, or title you want to cite.</p></div></li>
              <li className="num-step"><span className="num-badge">4</span><div><h3>Review the Citation</h3><p>Check that the author, title, date, and URL look correct.</p></div></li>
              <li className="num-step"><span className="num-badge">5</span><div><h3>Copy It</h3><p>Copy the full citation, and the in-text citation when available, into your reference list.</p></div></li>
            </ol>
          </div>
        </section>

        {/* ===== BY SOURCE ===== */}
        <section className="section" id="source-types">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">By source</span>
              <h2>Generate Citations by Source Type</h2>
            </div>
            <div className="grid-3 stagger">
              {SOURCE_TYPES.map((item) => (
                <div className="type-card" key={item.tag}>
                  <span className="type-tag"><Icon name={item.icon} />{item.tag}</span>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== EXAMPLES ===== */}
        <section className="section section-alt" id="examples">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">See it in action</span>
              <h2>Example Citations</h2>
            </div>
            <div className="examples-grid">
              {EXAMPLE_CARDS.map((ex) => (
                <div className="example-card" key={ex.tag}>
                  <span className="example-tag">{ex.tag}</span>
                  <p className="cite-line">{ex.cite}</p>
                  <p className="intext-line">{ex.intext}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== WHY USE IT (THE PAYOFF) ===== */}
        <section className="section">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">The payoff</span>
              <h2>Why Use Our Free Citation Generator?</h2>
            </div>
            <div className="why-grid">
              {WHY_ITEMS.map((w) => (
                <div className="why-item" key={w.title}>
                  <div className="icon-circle"><Icon name={w.icon} /></div>
                  <h3>{w.title}</h3>
                  <p>{w.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== COMPARE PLANS ===== */}
        <section className="section section-alt" id="pricing">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">Compare plans</span>
              <h2>Free and Premium Features</h2>
            </div>
            <div className="table-wrap">
              <table className="comparison-table">
                <thead>
                  <tr><th>Feature</th><th>Free Version</th><th>Premium Version</th></tr>
                </thead>
                <tbody>
                  {PLAN_COMPARISON.map((row) => (
                    <tr key={row.feature}>
                      <td>{row.feature}</td>
                      <td><PlanCell value={row.free} /></td>
                      <td><PlanCell value={row.premium} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* ===== DETAILED GUIDE (existing per-style content) ===== */}
        {blogPosts[activeTab]?.content?.trim() && (
          <section className="section" id="guide">
            <div className="container">
              <div className="blog-content-card">
                <div className="blog-content" dangerouslySetInnerHTML={{ __html: blogPosts[activeTab].content }} />
              </div>
            </div>
          </section>
        )}

        {/* ===== AI RESEARCH ASSISTANT ===== */}
        <section className="section" id="ai-research-assistant">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">AI research assistant</span>
              <h2>AI Research Assistant for Smarter Citation Work</h2>
            </div>
            <div className="grid-2">
              <div className="card">
                <p>Creating a citation is only one part of academic referencing. Before citing a source, you may need to understand whether it actually supports your argument, identify the relevant publication details, choose the right citation style, or decide how a source should be used in your paper.</p>
                <br/>
                <p>The ResearchPal AI Research Assistant can help you work through those research questions alongside the free Citation Generator. You can ask about a source, discuss how it relates to your research question, and then use the citation generator to create the appropriate reference.</p>
                <br/>
                <p>ResearchPal's citation workflow supports source inputs such as URLs, DOIs, paper titles, ArXiv IDs and PubMed IDs, with formats including APA, Harvard, MLA, Chicago and BibTeX.</p>
              </div>
              <div className="card">
                <h3>Use the AI Research Assistant When You Need to:</h3>
                <ul className="check-list" style={{ marginTop: "10px" }}>
                  <li><Icon name="check" />Understand a paper before adding it to your references</li>
                  <li><Icon name="check" />Discuss how a source supports your research</li>
                  <li><Icon name="check" />Decide which citation information matters</li>
                  <li><Icon name="check" />Clarify citation and referencing questions</li>
                  <li><Icon name="check" />Work through sources while building an academic argument</li>
                  <li><Icon name="check" />Move from research discovery to citation without switching between unrelated tools</li>
                </ul>
              </div>
            </div>
            <div className="hero-ctas" style={{ marginTop: "30px" }}>
              <Link to="/ai-agent" className="btn-primary" style={{ textDecoration: "none" }}>Try AI Research Assistant</Link>
            </div>
          </div>
        </section>

        {/* ===== FREE TOOLS ===== */}
        <section className="section" id="free-tools">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">More free tools</span>
              <h2>Explore ResearchPal's Free Tools</h2>
            </div>

            <div className="free-tools-group">
              <h3 className="free-tools-group-title">ResearchPal Free Tools</h3>
              <div className="free-tools-grid">
                <Link className="free-tool-card" to="/paraphraser">
                  <div className="icon-circle"><Icon name="wand" /></div>
                  <div><h3>Paraphraser</h3><p>Rewrite sentences and paragraphs while keeping the meaning.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/ai-agent">
                  <div className="icon-circle"><Icon name="chat" /></div>
                  <div><h3>AI Agent</h3><p>Chat with an AI assistant built for research tasks.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/search">
                  <div className="icon-circle"><Icon name="search" /></div>
                  <div><h3>Search Papers</h3><p>Find and explore academic papers across sources.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/essay-writer">
                  <div className="icon-circle"><Icon name="edit" /></div>
                  <div><h3>Essay Writer</h3><p>Draft structured essays with AI assistance.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/literature-review">
                  <div className="icon-circle"><Icon name="book" /></div>
                  <div><h3>Literature Review</h3><p>Summarize and organize sources for your review.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/paper-insights">
                  <div className="icon-circle"><Icon name="chart" /></div>
                  <div><h3>Paper Insights</h3><p>Get quick, structured insights from any paper.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
              </div>
            </div>

            <div className="free-tools-group">
              <h3 className="free-tools-group-title">Free Citation Generators</h3>
              <div className="free-tools-grid">
                <Link className="free-tool-card" to="/citation-generator/apa">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>APA Citation Generator</h3><p>Format references in APA style instantly.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/citation-generator/harvard">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>Harvard Citation Generator</h3><p>Create author-date Harvard references.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/citation-generator/mla">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>MLA Citation Generator</h3><p>Generate MLA in-text and Works Cited entries.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/citation-generator/chicago">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>Chicago Citation Generator</h3><p>Build Notes-Bibliography or Author-Date citations.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/citation-generator/bibtex">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>BibTeX Generator</h3><p>Get ready-to-use BibTeX entries for LaTeX.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
                <Link className="free-tool-card" to="/citation-generator/metadata">
                  <div className="icon-circle"><Icon name="quote" /></div>
                  <div><h3>Metadata Lookup</h3><p>View a source's structured details before citing it.</p></div>
                  <Icon name="arrowRight" className="arrow" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ===== FINAL CTA ===== */}
        <section className="final-cta">
          <div className="bg-ambient" aria-hidden="true">
            <div className="blob blob-a" />
            <div className="blob blob-b" />
          </div>
          <div className="container final-cta-inner">
            <h2>Ready to Generate Your Citation?</h2>
            <p className="lede">Paste a link, DOI, ArXiv ID, PubMed ID, or title and get a formatted citation in seconds. It's free, with no sign-up required to try.</p>
            <div className="final-cta-actions">
              <span role="button" tabIndex={0} className="btn-primary" style={{ textDecoration: "none", cursor: "pointer" }} onClick={handleGetStarted} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleGetStarted(); } }}>Get Started</span>
              <Link className="btn-on-dark" to="/pricing" onClick={() => window.scrollTo(0, 0)}>See Pricing</Link>
            </div>
          </div>
        </section>

        {/* ===== FAQ ===== */}
        <section className="section section-alt" id="faq">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">Questions</span>
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="faq-list">
              {FAQS.map((f) => <FaqItem key={f.q} question={f.q} answer={f.a} />)}
            </div>
          </div>
        </section>
          </>
        )}

        <InstructionsDialog
          open={openGuidelines}
          onClose={() => setOpenGuidelines(false)}
        />

        <DuplicateReferenceDialog
          open={duplicateDialogOpen}
          onClose={handleCloseDuplicateDialog}
          onViewReference={handleViewDuplicateReference}
          referenceTitle={duplicateReferenceTitle}
          referenceFullText={duplicateReferenceFull}
        />

        {showScroll && (
          <button type="button" className="scroll-top-btn" onClick={scrollTop} aria-label="Scroll to top">
            <Icon name="arrowUp" />
          </button>
        )}
      </div>

      <Footer />

      {
        state.loginModal && (
          <Login open={state.loginModal} onClose={(e) => toggle(e)} />  // 'e' should be "loginModal" from Login component
        )
      }
      {
        state.forgotModal && (
          <ForgotPassword
            open={state.forgotModal}
            onClose={() => toggle("forgotModal")}
          />
        )
      }
      {
        state.signupModal && (
          <Signup
            open={state.signupModal}
            onClose={(target) => setState((prev) => ({ ...prev, signupModal: false, loginModal: target === "loginModal", forgotModal: target === "forgotModal" }))}
          />
        )
      }
      {/* <AIAgentWidget onLoginOpen={() => toggle("loginModal")} /> */}
    </>
  );
};

export default Indexbeforelogin;